/* global reportingUrl vikEnabled */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import { formatFigure, formatPayloadMoney } from 'Helpers/formatService';

import PaginationInfo from 'CommonComponents/PaginationInfo';
import TablePagination from 'CommonComponents/TablePagination';
import Tooltip from 'CommonComponents/Tooltip';

import usePagination from 'Hooks/usePagination';

import CircleHelpIconUrl from 'Assets/icons/circle-help.svg?url';

export default function PositionExpenditureOverviewTable(props) {
    const [positions, setPositions] = useState([]);

    useEffect(() => {
        fetchDepPositionsTree();
    }, []);

    const onPageChange = () => {
        fetchDepPositionsTree();
    };

    const pagination = usePagination({
        perPage: 10,
        onChange: onPageChange,
    });

    const { to, from, total, lastPage, perPage, page } = pagination;

    const fetchDepPositionsTree = () => {
        axios
            .post(props.reportingUrl, {
                params: {
                    per_page: perPage,
                    page,
                    sort_by: 'start_date',
                    sort_dir: 'desc',
                },
            })
            .then(({ data }) => {
                const { data: positions, ...meta } = data;
                setPositions(positions);
                // pagination.setLastPage(meta.last_page);
                pagination.setLastPage(1);
            })
            .catch((e) => console.log(e));
    };

    return (
        <div className="table__card">
            <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
                <div>
                    <h4 className="table__header">{$t('Expenditure')}</h4>
                    <div className="tw-flex tw-items-center tw-space-x-3">
                        <PaginationInfo to={to} from={from} total={total} />
                        <TablePagination lastPage={lastPage} pageChange={(data) => pagination.setPage(+data.selected + 1)} forcePage={page - 1} />
                    </div>
                </div>
                <div className="tw-flex tw-items-center tw-space-x-1.5">
                    <label htmlFor="expenditure-table_page_len" className="table__select-page-len__label">
                        {$t('Show')}
                    </label>
                    <select
                        id="expenditure-table_page_len"
                        className="table__select-page-len"
                        onChange={(e) => pagination.setPerPage(parseInt(e.target.value))}
                    >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </div>
            <div className="inbud-table_wrapper">
                <table className="inbud-table tw-table-fixed">
                    <thead>
                        <tr>
                            <th className="tw-w-56">{$t('Name')}</th>
                            <th className="tw-w-36">{$t('Cash')}</th>
                            {props.vikEnabled && (
                                <th className="tw-w-36">
                                    <Tooltip placement="bottom" tooltipContent={$t('tooltip.vik')} tooltipType="text">
                                        <div className="tw-flex tw-items-center tw-space-x-1">
                                            <div>{$t('VIK')}</div>
                                            <img src={CircleHelpIconUrl} className="tw-w-3 tw-h-3" />
                                        </div>
                                    </Tooltip>
                                    <div className="tw-flex tw-items-center tw-space-x-1"></div>
                                </th>
                            )}
                            <th className="tw-w-36">{$t('Total')}</th>
                            <th className="tw-w-36">{$t('Committed')}</th>
                            <th className="tw-w-36">{$t('Uncommitted')}</th>
                            <th className="tw-w-36">{$t('Count')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {positions.map((position, index) => (
                            <tr key={index}>
                                <td>
                                    <div>{position.name}</div>
                                </td>
                                <td className="inbud-numeric-cell">{formatFigure(position.cash, formatPayloadMoney)}</td>
                                {props.vikEnabled && <td className="inbud-numeric-cell">{formatFigure(position.vik, formatPayloadMoney)}</td>}
                                <td className="inbud-numeric-cell">{formatFigure(position.total, formatPayloadMoney)}</td>
                                <td className="inbud-numeric-cell">{formatFigure(position.committed, formatPayloadMoney)}</td>
                                <td className="inbud-numeric-cell">{formatFigure(position.uncommitted, formatPayloadMoney)}</td>
                                <td className="inbud-numeric-cell">{formatFigure(position.count, formatPayloadMoney)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

if (document.getElementById('PositionExpenditureOverviewTable')) {
    var rootEl = document.getElementById('PositionExpenditureOverviewTable');
    ReactDOM.render(
        <App>
            <PositionExpenditureOverviewTable reportingUrl={reportingUrl} vikEnabled={vikEnabled} />
        </App>,
        rootEl,
    );
}
